import React from "react";
import { Box, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";

const sortFields = [
    { value: "game_times", label: "Игровое время" },
    { value: "name", label: "Имя" },
    { value: "steam_id", label: "Steam ID" },
    { value: "created_at", label: "Первая игра" },
    { value: "updated_at", label: "Был в игре" },
];

const PlayersToolbar = ({ search, onSearchChange, sortBy, onSortChange }) => (
    <Box display="flex" gap={2} mt={2} flexDirection={{ xs: 'column', sm: 'row' }}>
        <TextField
            label="Поиск по нику или Steam ID"
            variant="outlined"
            size="small"
            fullWidth
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
        />
        <FormControl size="small" sx={{ minWidth: 200 }}>
            <InputLabel>Сортировка</InputLabel>
            <Select value={sortBy} label="Сортировка" onChange={(e) => onSortChange(e.target.value)}>
                {sortFields.map((field) => (
                    <MenuItem key={field.value} value={field.value}>{field.label}</MenuItem>
                ))}
            </Select>
        </FormControl>
    </Box>
);

export default PlayersToolbar;
